import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/shared/services/common.service';
import { HospitalProgramModel } from '../../../hospital.model';
import { HospitalService } from '../../../hospital.service';

@Component({
  selector: 'app-consult-form-program-list',
  templateUrl: './consult-form-program-list.component.html',
  styleUrls: ['./consult-form-program-list.component.css']
})
export class ConsultFormProgramListComponent implements OnInit {
  hospitalId: number;
  hospitalPrograms: any[];
  consultFormReturnUrl: string;
  programCoverageReturnUrl: string;
  constructor(private activatedRoute: ActivatedRoute, private hospitalService: HospitalService, private router: Router, private commonService: CommonService) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.hospitalId = params.id == undefined ? null : this.commonService.encryptDecryptValue(params.id, false);
      if (this.hospitalId != 0 && this.hospitalId != null) {
        this.getHospitalInfo();
      }
    });
    if (localStorage.getItem('isHospital')) {
      this.consultFormReturnUrl = '/web/hospital/add-consult-form';
      this.programCoverageReturnUrl = '/web/hospital/program-coverage';
    }
    else {
      this.consultFormReturnUrl = '/web/hospitals/add-consult-form';
      this.programCoverageReturnUrl = '/web/hospitals/program-coverage';
    }

  }

  getHospitalInfo() {
    this.hospitalService.getById(this.hospitalId, false).subscribe((response: any) => {
      if (response != null) {
        response.hospitalPrograms = response.hospitalPrograms.filter(p => p.isActive == true);
        this.hospitalPrograms = (response.hospitalPrograms || []).map((x, i) => {
          return {
            id: x.id,
            programName: x.programName.toUpperCase(),
            signOffTimeFrame: x.signOffTimeFrame,
            isConsultUrgentAttention: x.isConsultUrgentAttention

          }
        })
      }
    });
  }

  openHospitalProgramConsultForm(id: number) {
    this.hospitalService.getCurrentAvailableDoctorByProgramId(id, 0).subscribe((response: any) => {
      if (response != null) {
        if (response.availableDoctor != null)
          this.router.navigate([this.consultFormReturnUrl],
            { queryParams: { id: this.commonService.encryptDecryptValue(this.hospitalId, true), hpId: this.commonService.encryptDecryptValue(id, true), did: this.commonService.encryptDecryptValue(response.availableDoctor.id, true) } });
        else {
          this.router.navigate([this.programCoverageReturnUrl], { queryParams: { hpId: this.commonService.encryptDecryptValue(id, true) } });
          // this.router.navigate(["/web/hospitals/add-consult-form"],
          //   { queryParams: { id: this.hospitalId, hpId: id, did: 6 } });
        }
      }
    });
  }

}
